// src/components/ui/PageSizeSelect.jsx
import React from "react";

const PageSizeSelect = ({
  value,
  onChange,
  options = [10, 20, 50, 100, 500],
  className = "",
}) => (
  <div className={`flex items-center gap-1.5 ${className}`}>
    <label htmlFor="pageSize" className="text-xs text-gray-400 whitespace-nowrap">
      Por página
    </label>
    <select
      id="pageSize"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="text-xs border border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-blue-400 focus:outline-none"
    >
      {options.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
  </div>
);

export default PageSizeSelect;
